import getEnvironmentName from './getEnvironmentName';

// Note: we use includes() here instead of strict equality check because
// we want to allow for environment names such as "prod-next" or "prod-2"
// to be treated as prod environments
const isRunningOnProd = getEnvironmentName()?.includes('prod');

const isProd = () => isRunningOnProd;

export default isProd;
